// genrate page for  invoces
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
} from "@material-ui/core";
import TablePaginationActions from "@material-ui/core/TablePagination/TablePaginationActions"; // optional if you keep custom actions
import { fetchPartialAndNoPaidInvoicesAction } from "../../actions/invoiceActions";
import Spinner from "../Spinner/Spinner";
import moment from "moment";

const useStyles = makeStyles({
  table: {
    minWidth: 500,
  },
  tablecell: {
    fontSize: "16px",
    textAlign: "center",
  },
});

const InvoicesWithRest = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const invoices = useSelector((state) => state.invoices.invoices);
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const classes = useStyles();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  console.log(user);
  useEffect(() => {
    if (user) {
      dispatch(fetchPartialAndNoPaidInvoicesAction(user?.result?.userId[0]));
    } else {
      history.push("/login");
    }
  }, [dispatch, user, history]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading) {
    return (
      <div style={{ paddingTop: "20px", textAlign: "center" }}>
        <Spinner />
      </div>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Number</TableCell>
            <TableCell>Client</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Due Date</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? invoices.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
            : invoices
          ).map((row) => (
            <TableRow key={row._id}>
              <TableCell>{row.invoiceNumber}</TableCell>
              <TableCell>{row?.client?.name}</TableCell>
              <TableCell>
                {row.currency} {row.total}
              </TableCell>
              <TableCell>{moment(row.dueDate).format("YYYY-MM-DD")}</TableCell>
              <TableCell>{row.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              colSpan={5}
              count={invoices.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default InvoicesWithRest;
